import { useEffect, useState } from 'react';
import { formatUtcCountdown, getMsUntilUtcMidnight, getUtcDayKey } from '../simulation/dailySeed.ts';

export function useUtcCountdown() {
  const [dayKey, setDayKey] = useState(getUtcDayKey());
  const [countdown, setCountdown] = useState(formatUtcCountdown(getMsUntilUtcMidnight()));

  useEffect(() => {
    const tick = () => {
      const today = getUtcDayKey();
      setDayKey(today);
      setCountdown(formatUtcCountdown(getMsUntilUtcMidnight()));
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return { dayKey, countdown };
}
